import { css } from '@/styled-system/css';

export const rowList = css({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
});

export const row = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  fontSize: 'md',
  color: 'hpxBlue500',
  lineHeight: '1.5',
});

export const icon = css({
  width: '20px',
  height: '20px',
  flexShrink: 0,
});

export const ctaEmphasis = css({
  textTransform: 'uppercase',
});

export const ctaButton = css({
  appearance: 'none',
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  color: 'hpxTeal500',
  fontWeight: 'bold',
  textDecoration: 'none',
  cursor: 'pointer',
  _hover: {
    textDecoration: 'underline',
    color: 'hpxTeal600',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderRadius: '2px',
  },
});
